import {ResultWithHighlight} from './result-with-highlight';

export class SuggestionComplex {

  type: string;

  suggestions: ResultWithHighlight[] = [];

  constructor(attr: { type, suggestions: any[] }) {
    this.type = attr.type;
    if (attr.suggestions) {
      attr.suggestions.forEach(suggestion => this.suggestions.push(new ResultWithHighlight(suggestion)));
    }
  }

  hasResults(): boolean {
    return this.suggestions != null && this.suggestions.length > 0;
  }

}
